/** @license Material-UI v4.12.2
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  borders: true,
  breakpoints: true,
  compose: true,
  styleFunctionSx: true,
  display: true,
  flexbox: true,
  grid: true,
  palette: true,
  positions: true,
  shadows: true,
  sizing: true,
  spacing: true,
  style: true,
  typography: true
};
Object.defineProperty(exports, "borders", {
  enumerable: true,
  get: function get() {
    return _borders.default;
  }
});
Object.defineProperty(exports, "breakpoints", {
  enumerable: true,
  get: function get() {
    return _breakpoints.default;
  }
});
Object.defineProperty(exports, "compose", {
  enumerable: true,
  get: function get() {
    return _compose.default;
  }
});
Object.defineProperty(exports, "styleFunctionSx", {
  enumerable: true,
  get: function get() {
    return _styleFunctionSx.default;
  }
});
Object.defineProperty(exports, "display", {
  enumerable: true,
  get: function get() {
    return _display.default;
  }
});
Object.defineProperty(exports, "flexbox", {
  enumerable: true,
  get: function get() {
    return _flexbox.default;
  }
});
Object.defineProperty(exports, "grid", {
  enumerable: true,
  get: function get() {
    return _grid.default;
  }
});
Object.defineProperty(exports, "palette", {
  enumerable: true,
  get: function get() {
    return _palette.default;
  }
});
Object.defineProperty(exports, "positions", {
  enumerable: true,
  get: function get() {
    return _positions.default;
  }
});
Object.defineProperty(exports, "shadows", {
  enumerable: true,
  get: function get() {
    return _shadows.default;
  }
});
Object.defineProperty(exports, "sizing", {
  enumerable: true,
  get: function get() {
    return _sizing.default;
  }
});
Object.defineProperty(exports, "spacing", {
  enumerable: true,
  get: function get() {
    return _spacing.default;
  }
});
Object.defineProperty(exports, "style", {
  enumerable: true,
  get: function get() {
    return _style.default;
  }
});
Object.defineProperty(exports, "typography", {
  enumerable: true,
  get: function get() {
    return _typography.default;
  }
});

var _borders = _interopRequireWildcard(require("./borders"));

Object.keys(_borders).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _borders[key];
    }
  });
});

var _breakpoints = _interopRequireDefault(require("./breakpoints"));

var _compose = _interopRequireDefault(require("./compose"));

var _styleFunctionSx = _interopRequireWildcard(require("./styleFunctionSx"));

Object.keys(_styleFunctionSx).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _styleFunctionSx[key];
    }
  });
});

var _display = _interopRequireDefault(require("./display"));

var _flexbox = _interopRequireWildcard(require("./flexbox"));

Object.keys(_flexbox).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _flexbox[key];
    }
  });
});

var _grid = _interopRequireWildcard(require("./grid"));

Object.keys(_grid).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _grid[key];
    }
  });
});

var _palette = _interopRequireWildcard(require("./palette"));

Object.keys(_palette).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _palette[key];
    }
  });
});

var _positions = _interopRequireWildcard(require("./positions"));

Object.keys(_positions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _positions[key];
    }
  });
});

var _shadows = _interopRequireDefault(require("./shadows"));

var _sizing = _interopRequireWildcard(require("./sizing"));

Object.keys(_sizing).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _sizing[key];
    }
  });
});

var _spacing = _interopRequireWildcard(require("./spacing"));

Object.keys(_spacing).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _spacing[key];
    }
  });
});

var _style = _interopRequireDefault(require("./style"));

var _typography = _interopRequireWildcard(require("./typography"));

Object.keys(_typography).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _typography[key];
    }
  });
});


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/system/index.js
// module id = 261
// module chunks = 0